import { render, staticRenderFns } from "./BaseRouterView.vue?vue&type=template&id=daa90be6&"
import script from "./BaseRouterView.vue?vue&type=script&lang=js&"
export * from "./BaseRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports